<script lang="ts" module>
  import { marked } from 'marked';

  import { TeoCore } from '@/teoCore/TeoCore';
  import { executeActionString, isActionString } from '@/teoCore/utility/actionString';

  import { createMdRenderer } from './createMdRenderer';

  const renderer = createMdRenderer({
    heading: ['text-md', 'font-bold', 'mb-4'],
    link: ['text-c-link', 'font-bold', 'underline'],
    strong: ['font-bold'],
    em: ['italic'],
    list: ['list-disc', 'ml-4'],
    paragraph: ['mb-4', 'color-red'],
  });

  marked.setOptions({ breaks: true });
  marked.use({ renderer });
</script>

<script lang="ts">
  let { markdown }: { markdown: string } = $props();
  let html = $derived(markdown ? marked(markdown) : '');
  let container: HTMLElement;

  $effect(() => {
    container.addEventListener('click', onTextClick);
    return () => {
      container.removeEventListener('click', onTextClick);
    };
  });

  function onTextClick(e: MouseEvent) {
    if (e.target instanceof HTMLAnchorElement) {
      const href = e.target.attributes.getNamedItem('href')?.value;
      if (href && isActionString(href)) {
        e.preventDefault();
        e.stopPropagation();
        executeActionString(TeoCore.current, href);
        console.log('action string:', href);
      }
    }
  }
</script>

<div class="teo-markdown-text [&>p:last-child]:mb-0" bind:this={container}>
  <!--eslint-disable-next-line svelte/no-at-html-tags-->
  {@html html}
</div>
